<!-- Componente principal para el registro de profesionales -->
<div class="container">
    <!-- Loader para mostrar durante cargas -->
    <shared-loader *ngIf="_showLoader"></shared-loader>

    <!-- Sección de inicio de trámite para clientes de ventanilla -->
    <div class="col-12">
        <!-- Tarjeta principal -->
        <div *ngIf="loginService.hasRoles(['cliente_ventanilla'])" class="process-card">

            <!-- Encabezado -->
            <div class="process-header">
                <h2 class="process-title">Registro de Profesionales y Prestadores de Servicios de Urbanización y
                    Construcción</h2>
                <p class="process-subtitle">Complete los siguientes pasos para iniciar su solicitud.</p>
            </div>

            <!-- Contenido en dos columnas (imagen + formulario) -->
            <div class="process-content">
                <!-- Columna izquierda - Visualización del proceso -->
                <div class="process-visual">
                    <div class="process-image-container">
                        <!-- Imagen que cambiará según el ámbito -->
                        <img class="process-image" [src]="procesoDetectado.imageSrc"
                            (error)="procesoDetectado.imageSrc = defaultImage" alt="Ilustración del proceso">

                        <!-- Barra de progreso con color dinámico -->
                        <div class="process-progress">
                            <div class="progress-bar" [ngClass]="procesoDetectado.bgColor"></div>
                        </div>

                        <!-- Título y descripción dinámicos -->
                        <h3 class="process-step-title">{{ procesoDetectado.title }}</h3>
                        <p class="process-step-description">{{ labelIniciarTramite }}</p>
                    </div>


                    <!-- Información del usuario en sidebar -->
                    <div class="user-info-card">
                        <div class="user-avatar">
                            <i class="pi pi-user"></i>
                        </div>
                        <div class="user-details">
                            <h4>{{ loginService.session()?.perfil?.nombreCompleto }}</h4>
                            <p>{{ formatearDocumento(loginService.session()?.perfil?.documento) | titlecase }}</p>
                        </div>
                    </div>
                </div>

                <!-- Columna derecha - Formulario del proceso -->
                <div class="process-form">
                    <!-- Selector de ámbito con pestañas -->
                    <div class="ambit-tabs">
                        <div *ngFor="let ambito of ambitosMenu" class="ambit-tab"
                            [class.active]="ambitoActivoId === ambito.idAmbito" (click)="onAmbitoClick(ambito)"
                            (mouseenter)="actualizarImagen(ambito.descripcionAmbito, ambito)"
                            (mouseleave)="ambitoActivoId === ambito.idAmbito ? null : resetProcesoDetectado()">
                            {{ ambito.descripcionAmbito | titlecase }}
                        </div>
                    </div>

                    <!-- Contenido del formulario por ámbito -->
                    <div *ngFor="let ambito of ambitos" class="ambit-form-content"
                        [class.active]="ambitoActivoId === ambito.idAmbito">

                        <h3 class="form-section-title">{{ ambito.descripcionAmbito | uppercase }}</h3>

                        <!-- Campo de categoría -->
                        <div class="form-field">
                            <label>Categoría</label>
                            <p-dropdown [options]="ambito.clasificaciones" optionLabel="descripcion"
                                optionValue="descripcion" [autoDisplayFirst]="false" [scrollHeight]="'300px'"
                                [appendTo]="'body'" panelStyleClass="wide-dropdown-panel"
                                styleClass="w-full force-full-width" placeholder="Seleccione una categoría"
                                [(ngModel)]="seleccionCategoria[ambito.idAmbito]"
                                (onChange)="onCategoriaChange(ambito)">
                            </p-dropdown>
                        </div>

                        <!-- Campo de profesión -->
                        <div class="form-field" *ngIf="profesionesFiltradas[ambito.idAmbito]?.length">
                            <label>Profesión</label>
                            <p-dropdown [options]="profesionesFiltradas[ambito.idAmbito]"
                                [(ngModel)]="seleccionProfesion[ambito.idAmbito]" [filter]="true"
                                [autoDisplayFirst]="false" [scrollHeight]="'300px'" [appendTo]="'body'"
                                panelStyleClass="wide-dropdown-panel" styleClass="w-full force-full-width"
                                placeholder="Seleccione una profesión" optionLabel="descripcion" [optionValue]=""
                                optionDisabled="disabled" (onChange)="onProfesionChange($event.value, ambito)">
                                <ng-template let-prof pTemplate="item">
                                    <div class="profession-option">
                                        <strong>{{ prof.descripcion }}</strong>
                                        <span class="profession-action">{{ (prof.accion!='Ninguna' ? prof.accion : (this.infoPersona.idTipoPersona === 1 ? 'Vigente' : 'No disponible')) | titlecase }}</span>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div>

                        <!-- Botón de acción -->
                        <div class="form-actions">
                            <p-button (click)="iniciarTramite();" [disabled]="!puedeIniciar"
                                [routerLink]="['crearSolicitud']" class="start-process-button">
                                <i class="pi pi-play mr-2"></i>
                                <span style="display: inline-block;">
                                    Iniciar Trámite
                                </span>
                            </p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Sección de listado de profesionales registrados -->
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h2>Listado de Solicitudes</h2>
                <hr />

                <!-- Componente de listado de proyectos -->
                <lista-proyectos [titulo]="'  '" [ocultarBotonNuevo]="true" [mostrarFiltros]="true"
                    [cardStyle]="'background-color: #f5f5f5;'" [skipOnInit]="false" [proyectos]="proyectos"
                    [hideNoTramites]="true" (itemClicked)="onItemProyectoClicked($event)">
                </lista-proyectos>
            </div>
        </div>
    </div>
</div>